<template>
    <div class="card card-highlighted">
          <div class="card-body">
            <h4 class="card-title">You are the {{getBuyerSellerType()}}</h4>
          </div>
<!--        <div class="card-body" v-if="contract.type === 'SALE' && contract.owner.id === currentOrg.id">-->
<!--            <h4 class="card-title">You are the seller</h4>-->
<!--        </div>-->
<!--        <div class="card-body" v-if="contract.partner_id === currentOrg.id">-->
<!--            <h4 class="card-title">You are the buyer</h4>-->
<!--        </div>-->
        <div class="card-body">
            <div class="d-flex flex-row" v-if="contract.marketplace_id === currentOrg.marketplace_id">
                <div class="">
                    <blockie :address="contract.owner.biz_email" :width="100"></blockie>
                </div>
                <div class="p-l-20">
                    <h3 class="font-medium">{{contract.owner.biz_name}}</h3>
                    <h6>{{getBuyerSellerType()}}</h6>
                </div>
            </div>
            <div class="d-flex flex-row" v-if="contract.partner_id === currentOrg.id">
                <div class="">
                    <blockie :address="contract.counterparty.biz_email" :width="100"></blockie>
                </div>
                <div class="p-l-20">
                    <h3 class="font-medium">{{contract.counterparty.biz_name}}</h3>
                    <h6>Seller</h6>
                </div>
            </div>
            <div class="row m-t-40">
                <div class="col b-r text-center">
                    <h3 class="font-light">{{contract.status}}</h3>
                    <h6>State</h6>
                </div>
                <div class="col text-center">
                    <h3 class="font-light" v-if="contract.total">{{contract.total | money }}</h3>
                    <h6>Total Amount</h6>
                </div>
            </div>
        </div>
        <div>
            <hr>
        </div>
<!--        <div class="card-body" v-if="contract.status === 'DRAFT' && contract.marketplace_id === currentOrg.marketplace_id">-->
<!--            <div class="text-center">-->
<!--                <h4><i class="fas fa-check-circle text-success"></i>&nbsp;You have created the contract.</h4>-->
<!--                <h4>Waiting for counter party to accept</h4>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="card-body" v-if="contract.status === 'ACCEPTED' && contract.partner_id === currentOrg.id">-->
<!--            <div class="text-center">-->
<!--                <h4><i class="fas fa-check-circle text-success"></i>&nbsp;You accepted the contract.</h4>-->
<!--                <h4>Waiting for counter party to confirm</h4>-->
<!--            </div>-->
<!--        </div>-->
        <template>
<!--            <marketplace-contract-accept :contractid="contract.id" v-if="contract.status === 'DRAFT'"></marketplace-contract-accept>-->
            <marketplace-contract-confirm :contractid="contract.id" v-if="contract.status === 'DRAFT'"></marketplace-contract-confirm>
            <complete v-if="contract.status === 'CONFIRMED'"></complete>
            <void v-if="contract.status === 'VOID'"></void>
        </template>
    </div>
</template>

<script>
    import Complete from "../../../express/contracts/sidebar/slots/Complete";
    import Void from "../../../express/contracts/sidebar/slots/Void";
    import MarketplaceContractConfirm from "./slots/MarketplaceContractConfirm";
    import MarketplaceContractPost from "./slots/MarketplaceContractAccept";
    import {mapGetters} from "vuex";
    import MarketplaceContractAccept from "./slots/MarketplaceContractAccept";
    import Blockie from "../../../common/Blockie";

    export default {
        name: "MarketplaceContractSidebar",
        components: {MarketplaceContractAccept, MarketplaceContractPost, MarketplaceContractConfirm, Void, Complete, Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        props: {
            contract: Object
        },
      methods: {
        getBuyerSellerType() {
          if (this.contract && this.contract.type === 'SALE' && this.contract.owner.id === this.currentOrg.id) {
            return 'Seller'
          }else if (this.contract && this.contract.type === 'SALE' && this.contract.counterparty.id === this.currentOrg.id) {
            return 'Buyer'
          }else if (this.contract && this.contract.type === 'PURCHASE' && this.contract.owner.id === this.currentOrg.id) {
            return  'Buyer'
          }else if (this.contract && this.contract.type === 'PURCHASE' && this.contract.counterparty.id === this.currentOrg.id) {
            return  'Seller';
          }
        }
      }
    }
</script>

<style scoped>

</style>
